import React from 'react';
import { HashRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import LandingPage from './components/LandingPage';
import AuthPage from './components/AuthPage';
import Dashboard from './components/Dashboard';
import ReceiptsDetail from './components/ReceiptsDetail';
import NavBar from './components/NavBar';
import CheckoutPage from './components/CheckoutPage';
import SubscriptionSuccessPage from './components/SubscriptionSuccessPage';
import ExportCenter from './components/ExportCenter';
import RequestPasswordReset from './components/RequestPasswordReset';
import ResetPassword from './components/ResetPassword';
import Footer from './components/Footer'; // Add this import
import './App.css';
import { CategoryProvider } from './utils/CategoryContext';
import { PWAProvider } from './context/PWAContext';
import { UploadProvider } from './contexts/UploadContext';

// Create a dark theme
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#111827', // Tailwind's gray-900
      paper: '#1f2937',   // Tailwind's gray-800
    },
    primary: {
      main: '#3b82f6', // Tailwind's blue-500
    },
    secondary: {
      main: '#10b981', // Tailwind's emerald-500
    },
  },
});

function AppContent() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/receipts') || location.pathname.startsWith('/exports');

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div className="App min-h-screen flex flex-col bg-gray-900 text-white">
        <NavBar isDashboard={isDashboard} />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/receipts" element={<ReceiptsDetail />} />
            <Route path="/receipts/:receiptId" element={<ReceiptsDetail />} />
            <Route path="/exports" element={<ExportCenter />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
            <Route path="/forgot-password" element={<RequestPasswordReset />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </div>
        <Footer /> {/* Add the Footer component here */}
      </div>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <CategoryProvider>
        <PWAProvider>
          <Router>
            <UploadProvider>
              <AppContent />
            </UploadProvider>
          </Router>
        </PWAProvider>
      </CategoryProvider>
    </ThemeProvider>
  );
}

export default App;
